import { lllLookupService } from "modules/lll/lll-lookup"
import { LllNode } from "modules/lll/lll-nodes"


export class LllNodeBranch {

  private nodes: LllNode[] = [];

  private constructor(nodes: LllNode[]) {
    this.nodes = nodes;
  }

  get description(): string {
    const result = this.nodes.map( e => e.displayName || e.name)
      .join(' -> ')
    return result;
  }

  get topicDisplay(): string {
    const types: LllNode['type'][] = ['subject', 'topic'];

    return this.nodes.filter( e => types.includes(e.type))
      .map(e => e.displayName || e.name)
      .join(' -> ');
  }

  get activityDisplay(): string {
    const types: LllNode['type'][] = ['activity-group', 'activity'];

    return this.nodes.filter( e => types.includes(e.type))
      .map(e => e.displayName || e.name)
      .join(' -> ');
  }


  static createTo(toNode: LllNode) {
    const flatNodes = lllLookupService.flatNodes;
    const branchNodes = [];
    let node = toNode;

    if(toNode) {
      branchNodes.push(toNode);
    }

    while(node) {
      const fqn = node.fqn;
      const lastIdx = fqn.lastIndexOf('~');

      if(lastIdx === -1) {
        break;
      }

      const parentFqn = fqn.substring(0, lastIdx);
      const parentNode = flatNodes[parentFqn];
      if(parentNode) {
        branchNodes.unshift(parentNode);
      }
      node = parentNode;

    }

    return new LllNodeBranch(branchNodes);
  }

}